import React from "react";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";
import { WeekDaysDesktop } from "./WeekDaysDesktop";
import { WeekDaysMobile } from "./WeekDaysMobile";

interface WeekDaysProps {
  date: string;
}

export const WeekDays: React.FC<WeekDaysProps> = ({ date }) => {
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;

  if (isMobile) {
    return <WeekDaysMobile date={date} />;
  }

  return <WeekDaysDesktop date={date} />;
};

